module.exports = __webpack_public_path__ + "static/img/aicon02.03e567e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aicon02.png
// module id = 1437
// module chunks = 3